'use strict'
import controller from './cierre.controller';
import template from './cierre.html';

const cierre = {
	bindings:{
		proyecto: '=',
		modoVista: '<'
	},
	controller,
	template
};

export default cierre;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/cierre/cierre.component.js